import { render, staticRenderFns } from "./TopicCardComponent.vue?vue&type=template&id=340623c6&scoped=true&"
import script from "./TopicCardComponent.vue?vue&type=script&lang=js&"
export * from "./TopicCardComponent.vue?vue&type=script&lang=js&"
import style0 from "./TopicCardComponent.vue?vue&type=style&index=0&id=340623c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "340623c6",
  null
  
)

export default component.exports